export const SALES_PAID_TYPES = [
    { label: 'Paid With Cash', value: 'cash' },
    { label: 'Credit Management', value: 'credit_management' },
    // { label: 'Paid with Credit Note', value: 'credit_note' },
    // { label: 'Paid with Cash & Credit Note', value: 'cash_and_credit_note' },
]